'use client'

import dynamic from 'next/dynamic'
import classNames from 'classnames'
import { useSiteContext, useTranslations } from '@dustin-web/microsite-components/src/hooks'
import { Icon } from '@dustin-web/microsite-components/src/icon-library'
import { MARKET_CUTOFF_TIME, shouldShowBanner } from './utils'

const Banner = dynamic(() =>
  import('@dustin-web/microsite-components/src/banners/banner').then(m => m.Banner)
)

type Props = {
  fullWidth?: boolean
  compact?: boolean
  className?: string
}

const ShippingCutoffBanner = ({ fullWidth, compact, className }: Props) => {
  const { translate } = useTranslations()
  const { sourcingCompany } = useSiteContext()

  if (!shouldShowBanner(sourcingCompany)) {
    return null
  }

  const banner = (
    <Banner
      color="light-green"
      closeable={false}
      fullWidth={fullWidth}
      className={classNames({ compact: compact })}>
      <div className="d-flex align-items-center">
        <Icon name="clock" className={classNames('i-16 u-mr-8', { 'i-20': fullWidth })} />
        <div className="text-button-container d-flex flex-column flex-md-row justify-content-md-between">
          <div className="text-block">
            <p className="u-mb-0 u-fs-14">
              {translate('Shipping_Cutoff_Banner', {
                time: MARKET_CUTOFF_TIME.get(sourcingCompany),
              })}
            </p>
          </div>
        </div>
      </div>
    </Banner>
  )

  if (className) {
    return <div className={className}>{banner}</div>
  }

  return banner
}

export default ShippingCutoffBanner
